import { INSURANCE_TYPES } from "./bookingConstants";
import s from "./InsuranceForm.module.css";

const Stepper = ({ value, onChange, min = 0 }) => (
  <div className={s.stepperWrap}>
    <input className={`${s.input} ${s.stepperVal}`} type="number" min={min} value={value} onChange={(e) => onChange(parseInt(e.target.value) || min)} />
    <button type="button" className={s.stepperBtn} onClick={() => onChange(Math.max(min, value - 1))}>−</button>
    <button type="button" className={s.stepperBtn} onClick={() => onChange(value + 1)}>+</button>
  </div>
);

const InsuranceForm = ({ form, f }) => (
  <>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#eff6ff", color: "#2563eb" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        </div>
        <span className={s.formCardTitle}>Insurance Information</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Insurance Type</label><select className={s.input} value={form.insuranceType} onChange={e=>f("insuranceType",e.target.value)}><option value="">Select...</option>{INSURANCE_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
          <div className={s.field}><label className={s.fieldLabel}>Insurance Name</label><input className={s.input} value={form.insuranceName} onChange={e=>f("insuranceName",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Coverage Area</label><input className={s.input} placeholder="e.g. Worldwide, Europe" value={form.coverageArea} onChange={e=>f("coverageArea",e.target.value)}/></div>
        </div>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Insurance ID</label><input className={s.input} placeholder="Policy / certificate number" value={form.insuranceIdNumber} onChange={e=>f("insuranceIdNumber",e.target.value)}/></div>
          <div className={s.field}/><div className={s.field}/>
        </div>
      </div>
    </div>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#fef3c7", color: "#d97706" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        </div>
        <span className={s.formCardTitle}>Dates</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Insurance Start Date</label><input className={s.input} type="date" value={form.insuranceStartDate} onChange={e=>f("insuranceStartDate",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Holiday Start Date</label><input className={s.input} type="date" value={form.holidayStartDate} onChange={e=>f("holidayStartDate",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Insurance Expire Date</label><input className={s.input} type="date" value={form.insuranceExpireDate} onChange={e=>f("insuranceExpireDate",e.target.value)}/></div>
        </div>
      </div>
    </div>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#f0fdf4", color: "#16a34a" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        </div>
        <span className={s.formCardTitle}>Insured Persons</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Number of Insured Persons</label><Stepper value={form.numberOfPersons||1} min={1} onChange={v=>f("numberOfPersons",v)}/></div>
          <div className={s.field}/><div className={s.field}/>
        </div>
      </div>
    </div>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#f5f3ff", color: "#7c3aed" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        </div>
        <span className={s.formCardTitle}>Notes</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.field}><label className={s.fieldLabel}>Invoice Notes</label><textarea className={`${s.input} ${s.textarea}`} rows={3} value={form.invoiceNotes||""} onChange={e=>f("invoiceNotes",e.target.value)}/></div>
        <div className={s.field}><label className={s.fieldLabel}>Office Notes</label><textarea className={`${s.input} ${s.textarea}`} rows={3} value={form.officeNotes||""} onChange={e=>f("officeNotes",e.target.value)}/></div>
      </div>
    </div>
  </>
);

export default InsuranceForm;
